import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import OrganizationSwitcher from './OrganizationSwitcher';
import ProjectSwitcher from './ProjectSwitcher';
import ProfileMenu from './ProfileMenu';
import SidebarMenu from './menu/SidebarMenu';
import LoadingSpinner from './LoadingSpinner';
import Logo from './Logo';

export default function Layout() {
  const { darkMode } = useTheme();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isAdminPage = location.pathname === '/admin';
  const shouldHideSidebar = isHomePage || isAdminPage;

  return (
    <div className={`flex h-screen ${darkMode ? 'dark' : ''}`}>
      {/* Sidebar - Hide on home page and admin page */}
      {!shouldHideSidebar && (
        <div className="hidden md:flex md:flex-shrink-0">
          <div className="flex flex-col w-64">
            <div className="flex items-center h-16 flex-shrink-0 px-8 bg-gray-200 dark:bg-dark-200 border-b border-gray-300 dark:border-dark-300">
              <span className="text-xl font-bold text-accent-primary">
                <Logo size="small" />
              </span>
            </div>
            <div className="flex-1 flex flex-col overflow-y-auto bg-gray-200 dark:bg-dark-200">
              <SidebarMenu />
            </div>
          </div>
        </div>
      )}

      {/* Main content */}
      <div className="flex flex-col flex-1">
        {!shouldHideSidebar && (
          <div className="relative z-10 flex-shrink-0 flex h-16 bg-gray-200 dark:bg-dark-200 border-b border-gray-300 dark:border-dark-300">
            <div className="flex-1 px-4 flex justify-end">
              <div className="flex items-center space-x-4">
                <OrganizationSwitcher />
                <ProjectSwitcher />
                <ProfileMenu />
              </div>
            </div>
          </div>
        )}

        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <div className={`${shouldHideSidebar ? '' : 'py-6'}`}>
            <div className={`${shouldHideSidebar ? '' : 'px-4 sm:px-6 md:px-8'}`}>
              <Suspense fallback={<LoadingSpinner />}>
                <Outlet />
              </Suspense>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
} 